<template>
  <div id="app" v-cloak @click="test">
    <router-view :key="key" />

    <StudioIntro></StudioIntro>

    <footer class="container">
      深圳天安骏业投资发展集团 版权所有  粤ICP备12026140号-5 | 网站策划与设计： <em><span class="gzs">天安云谷设计工作室</span></em> | 技术支持：深圳智慧园区信息技术有限公司
    </footer>

  </div>
</template>

<script>
  import StudioIntro from "./components/StudioIntro"

  export default {
    name: 'App',
    components: {
      StudioIntro
    },
    computed:{
      key(){
        return this.$route.name?this.$route.name +  new Date(): this.$route + new Date();
      }
    },
    methods: {
      test(){
        this.$store.dispatch('updateStatus',false)
      }
    }
  }
</script>

<style>
    [v-cloak] {
        display: none !important;
    }
    .a_content img{ max-width: 100% !important; }
    .gzs{ cursor: pointer; }
    .company-info .dec p,.company-info .dec a,.servcieDetail .detail > div{ color: #959595 !important; }
    .servcieDetail .detail > div{ font-size: 14px !important;  }
</style>

<style lang="scss">
  @font-face {
    font-family: 'numFont';
    src: url('./assets/font/IMPACT.ttf')
  }
  @import "./assets/scss/theme.scss";
  @import "./assets/scss/common.scss";

  @font-face {
    font-family: 'imapct';
    src: url('./assets/font/308-CAI978.ttf');
  }
  #app{
    position: relative; overflow: hidden;
  }
  @media screen and (max-width: 1590px) {
    body {
      height: 900px;
    }
  }
  footer {
    position: absolute;
    z-index: 1;
    bottom: 5px;
    text-align: center;
    line-height: 30px;
    font-size: 12px;
    color: #c5c5c5;

    span {
      color: #c5c5c5;
      cursor: pointer;
      text-decoration: underline;
    }
  }


  
.scroller::-webkit-scrollbar { /*滚动条整体样式*/
  width: 6px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}

.scroller::-webkit-scrollbar-thumb { /*滚动条里面小方块*/
  border-radius: 6px;
  -webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.2);
  background: #535353;
}

.scroller::-webkit-scrollbar-track { /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
  background: #a1a1a1;
}

  .company-info .dec img{
    max-width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue